module.exports = __webpack_public_path__ + "img/2.783d0b7a.png";